export const PL = 'PL'
export const TCP = 'TCP'
export const JWT = 'JWT'
export const EXTERNAL = 'external'
